
import React from 'react';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { GripVertical } from 'lucide-react';
import ProfileShowcaseCard from './ProfileShowcaseCard';

interface DraggableProfileCardProps {
  id: string;
  pattern: string;
  profileData: {
    type: string;
    description: string;
    traits: string[];
    workStyle: string;
    communication: string;
  };
  exampleScores: {
    name: string;
    fullName: string;
    value: number;
    color: string;
    sampleSize?: number;
    contributors?: string[];
  }[];
  isRealData?: boolean;
  showSampleSize?: boolean;
}

const DraggableProfileCard: React.FC<DraggableProfileCardProps> = ({
  id,
  pattern,
  profileData,
  exampleScores,
  isRealData = false,
  showSampleSize = true
}) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ 
    id,
    resizeObserverConfig: {}
  });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.8 : 1,
  };

  return (
    <div
      ref={setNodeRef}
      style={style}
      className={`relative group ${isDragging ? 'z-50' : ''}`}
    >
      {/* Drag Handle */}
      <div
        {...attributes}
        {...listeners}
        className="absolute top-2 right-2 z-10 p-2 rounded-md bg-background/80 hover:bg-background shadow-sm border border-border opacity-0 group-hover:opacity-100 transition-opacity cursor-grab active:cursor-grabbing"
      >
        <GripVertical className="h-4 w-4 text-muted-foreground" />
      </div>

      <ProfileShowcaseCard
        pattern={pattern}
        profileData={profileData}
        exampleScores={exampleScores}
        isRealData={isRealData}
        showSampleSize={showSampleSize}
      />
    </div>
  );
};

export default DraggableProfileCard;
